import { useState } from 'react'
import { ExpandMore, ChevronRight, CloudUpload } from '@material-ui/icons'

import { DocumentDownload, Select } from '@base'
import { docTypeAll, MB_ROLES, strings } from '@constants'
import { DocUploadButton } from '@pages/Profile/styles'

import {
	BasicDetailsCard,
	CardHeader,
	CardTitle,
	ChevronBtn,
	SectionDivider,
	ExportControls,
	ExportSelectWrapper,
	ExportList,
	ExportRow,
	ExportName,
	ExportIconTile,
} from './style'
import { ExportDocumentsWrapper } from '../BasicDetails/style'

const ExportDocumentsCard = ({ invoiceData, userData, uploadExportDoc, deleteExportDoc, editable = false }) => {
	const [isOpen, setIsOpen] = useState(true)
	const [docType, setDocType] = useState('')

	const isAdmin = userData?.role === MB_ROLES.SUPER_ADMIN || userData?.role === MB_ROLES.ADMIN

	const availableTypes = docTypeAll.filter((item) => !invoiceData?.export_documents?.some((doc) => doc.document_type === item.name))

	const exportDocs = (invoiceData?.export_documents ?? []).filter((item) => (isAdmin ? true : item.only_admin === false))

	const handleUpload = (files) => {
		uploadExportDoc(docType, Array.from(files))
		setDocType('')
	}

	return (
		<BasicDetailsCard>
			<CardHeader $noBorder>
				<CardTitle>{strings('export', 'documents')}</CardTitle>
				<ExportDocumentsWrapper>
					<ExportControls>
						<ExportSelectWrapper>
							<Select
								primaryKey='aliasname'
								displayKey='aliasname'
								data={availableTypes}
								openBelow={false}
								value={docTypeAll.find((item) => item.name === docType) || {}}
								placeholder={strings('select_document_type')}
								onChange={(e) => setDocType(e.name)}
								required={false}
								small
							/>
						</ExportSelectWrapper>
					</ExportControls>
					<>
						{editable && (
							<DocUploadButton
								label={strings('upload')}
								icon={<CloudUpload fontSize='small' />}
								multiple
								disabled={!docType}
								onChange={handleUpload}
								xs
								uppercase
							/>
						)}
						<ChevronBtn onClick={() => setIsOpen((v) => !v)}>{isOpen ? <ExpandMore /> : <ChevronRight />}</ChevronBtn>
					</>
				</ExportDocumentsWrapper>
			</CardHeader>

			{isOpen && exportDocs.length > 0 && (
				<>
					<SectionDivider />
					<ExportList>
						{exportDocs.map((item, index) => (
							<ExportRow key={`${item.document_type}_${index}`}>
								<ExportName>{docTypeAll.find((val) => val.name === item.document_type)?.aliasname ?? item.document_type}</ExportName>
								<ExportIconTile>
									<DocumentDownload
										link={item.documents}
										type={item.document_type}
										onDelete={editable ? () => deleteExportDoc(item.documents?.[0], item.document_type) : undefined}
									/>
								</ExportIconTile>
							</ExportRow>
						))}
					</ExportList>
				</>
			)}
		</BasicDetailsCard>
	)
}

export default ExportDocumentsCard
